import noop from "lodash/noop";
import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";
import { trackPopupClick } from "../tracking";
import { useKeywordSuggestion } from "../useKeywordSuggestion";

import { MatchingKeywords } from "./MatchingKeywords";
import { SuggestedKeyword } from "./SuggestedKeyword";

const Container = styled(FlexColumn)`
    gap: 16px;
    height: 100%;
`;

export const Suggestions = () => {
    const { query, changeQuery, keywords, country, prependKeywords } = useKeywordListComposerContext();
    const { data: suggestedKeyword } = useKeywordSuggestion(query, country);
    const isAlreadyExists = keywords.some((keyword) => keyword.term === suggestedKeyword.term);

    const onClick = () => {
        prependKeywords([suggestedKeyword]);
        changeQuery("");
        trackPopupClick({ event: "Add Keyword", keyword: suggestedKeyword.term });
    };

    return (
        <Container>
            <SuggestedKeyword
                keyword={suggestedKeyword}
                onClick={isAlreadyExists ? noop : onClick}
                isAlreadyExists={isAlreadyExists}
            />
            <MatchingKeywords />
        </Container>
    );
};
